var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.$wf.isSmDown
    ? _c("w-select", {
        directives: [
          {
            name: "tooltip",
            rawName: "v-tooltip",
            value: _vm.$ct("tooltip.select-view"),
            expression: "$ct('tooltip.select-view')",
          },
        ],
        staticClass: "view-select",
        style: { flexShrink: 0 },
        attrs: { items: _vm.items, value: _vm.value, filter: "" },
        on: { input: _vm.onInput },
      })
    : _c(
        "w-dropdown",
        {
          directives: [
            {
              name: "tooltip",
              rawName: "v-tooltip",
              value: _vm.$ct("tooltip.select-view"),
              expression: "$ct('tooltip.select-view')",
            },
          ],
          attrs: { items: _vm.items, value: _vm.value, flat: "" },
          on: { click: _vm.onInput },
        },
        [_c("w-fa", { attrs: { icon: "filter" } })],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }